import store from '@/store'
import { getData, postData } from '@core/utils/http/general'

//* Save data
export const saveData = changes => new Promise((resolve, reject) => {
  const data = new FormData()
  data.append('task', 'wsperiodo')
  data.append('origin', process.env.VUE_APP_ORIGIN_API)
  data.append('token', store.state.cuenta.session.token)
  Object.entries(changes).forEach(element => { data.append(element[0], element[1]) })

  postData(data)
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

// * Get scheadule
export const getScheadule = periodo => new Promise((resolve, reject) => {
  getData({ action: 1, periodo, token: store.state.cuenta.session.token }, 'wscalendario')
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

// * Get types of events for scheadule
export const getTypes = () => new Promise((resolve, reject) => {
  getData({ action: 2, token: store.state.cuenta.session.token }, 'wscalendario')
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Save data
export const saveScheadule = changes => new Promise((resolve, reject) => {
  const data = new FormData()
  data.append('task', 'wscalendario')
  data.append('origin', process.env.VUE_APP_ORIGIN_API)
  data.append('token', store.state.cuenta.session.token)
  Object.entries(changes).forEach(element => { data.append(element[0], element[1]) })

  postData(data)
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
